import { styled } from 'styled-components';

import { colors, cssBreakpoints } from '#/theme/theme';

export const SmallHeader_Box_1 = styled.div`
  padding-block: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${colors.selectionGrey};

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    height: 100px;
    padding-block: 24px;
  }
`;
